module.exports = __webpack_public_path__ + "static/media/weight_loss_img.b5095bb5.svg";